
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderSaleReportDialog extends Serenity.EntityDialog<OrderSaleReportRow, any> {
        protected getFormKey() { return OrderSaleReportForm.formKey; }
        protected getIdProperty() { return OrderSaleReportRow.idProperty; }
        protected getLocalTextPrefix() { return OrderSaleReportRow.localTextPrefix; }
        protected getNameProperty() { return OrderSaleReportRow.nameProperty; }
        protected getService() { return OrderSaleReportService.baseUrl; }
        protected getDeletePermission() { return OrderSaleReportRow.deletePermission; }
        protected getInsertPermission() { return OrderSaleReportRow.insertPermission; }
        protected getUpdatePermission() { return OrderSaleReportRow.updatePermission; }

        protected form = new OrderSaleReportForm(this.idPrefix);

    }
}